import { withInstall } from '@sgui-plus/utils/with-install'
import InputNumber from './src/input-number.vue'

export const SgInputNumber = withInstall(InputNumber)

export default SgInputNumber
export * from './src/input-number'
